import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "features/store/Store";
// import { RootState } from "features/store/Store";

interface FilterIds {
  productId: any;
  BrandId: any;
  ModelId: any;
  CityId: any;
  RiderId: any;
  PromoCode: any;
  FromDate: any;
  ToDate: any;
  CompletedStartDate: any;
  CompletedEndDate: any;
  OffsetStart: number,
  RowsPerPage: number,
  productName: string,
  BrandName: string,
  ModalName: string,
  CityName: string,
  PromoCodeName: string,
  RiderName: string,
  AliasName: string,
}

export type routerPage = "ProductName" | "BrandName" | "ModalName" | "CityName" | "PromoCodeName" | "RiderName" |"AliasName"| "ProductId" | "BrandId" | "ModelId" | "CityId" | "RiderId" | "PromoCode" | "FromDate" | "ToDate" | "OffsetStart" | "RowsPerPage" | "CompletedStartDate" | "CompletedEndDate";

const initialState: FilterIds = {
  productId: 0,
  productName: "",
  BrandId: null,
  ModelId: null,
  CityId: null,
  RiderId: null,
  PromoCode: null,
  FromDate: null,
  ToDate: null,
  CompletedStartDate: null,
  CompletedEndDate: null,
  OffsetStart: 0,
  RowsPerPage: 50,
  BrandName: "",
  ModalName: "",
  CityName: "",
  PromoCodeName: "",
  RiderName: "",
  AliasName:""
};

const FilterGetId = createSlice({
  name: 'FilterId',
  initialState,
  reducers: {
    FilterDataId: (state, action: PayloadAction<{ payload: any, type: routerPage }>) => {
      switch (action.payload.type) {
        case "ProductId": {
          state.productId = action.payload.payload;
          return state;
        }
        case "ProductName": {
          state.productName = action.payload.payload;
          return state;
        }
        case "BrandName": {
          state.BrandName = action.payload.payload;
          return state;
        }
        case "ModalName": {
          state.ModalName = action.payload.payload;
          return state;
        }
        case "CityName": {
          state.CityName = action.payload.payload;
          return state;
        }
        case "RiderName": {
          state.RiderName = action.payload.payload;
          return state;
        }
        case "AliasName": {
          state.AliasName = action.payload.payload;
          return state;
        }
        case "PromoCodeName": {
          state.PromoCodeName = action.payload.payload;
          return state;
        }
        case "BrandId": {
          state.BrandId = action.payload.payload;
          return state;
        }
        case "ModelId": {
          state.ModelId = action.payload.payload;
          return state;
        }
        case "CityId": {
          state.CityId = action.payload.payload;
          return state;
        }
        case "RiderId": {
          state.RiderId = action.payload.payload;
          return state;
        }
        case "PromoCode": {
          state.PromoCode = action.payload.payload;
          return state;
        }
        case "FromDate": {
          state.FromDate = action.payload.payload;
          return state;
        }
        case "ToDate": {
          state.ToDate = action.payload.payload;
          return state;
        }
        case "CompletedStartDate": {
          state.CompletedStartDate = action.payload.payload;
          return state;
        }
        case "CompletedEndDate": {
          state.CompletedEndDate = action.payload.payload;
          return state;
        }
        case "OffsetStart": {
          state.OffsetStart = action.payload.payload;
          return state;
        }
        case "RowsPerPage": {
          state.RowsPerPage = action.payload.payload;
          return state;
        }
        default: return state;
      }
    },
  }
}
);

export const { FilterDataId } = FilterGetId.actions;
export const FilterProductId = (state: RootState) => state.FilterDataReducers;
export default FilterGetId.reducer;
